class ResourceNotFoundUsersController {
  static controller($scope, $state, ResourceService) {
    'ngInject';
  };
}

export default ResourceNotFoundUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/resource/notFound.resource.users.controller.js